export default __webpack_public_path__ + "static/media/logo.0d1526f9.png";